import reduceColorPointByRatio from '../utils/reduce-color-point-by-ratio';
import increaseColorPointByRatio from '../utils/increase-color-point-by-ratio';
import isDark from '../verifiers/is-dark';

const priceLabelAccent = (params) => {
  const {
    targetColor,
    backgroundColor,
    targetColorPalette,
    reduceCondition,
    increaseCondition,
  } = params;

  const fallback = {
    rule: 'priceLabel.background.primary',
    params,
  };

  if (isDark(backgroundColor)) {
    return reduceColorPointByRatio({
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: reduceCondition,
      fallback,
    });
  }

  return increaseColorPointByRatio(
    {
      targetColor,
      backgroundColor,
      targetColorPalette,
      condition: increaseCondition,
      fallback,
    },
    '50'
  );
};

export default priceLabelAccent;
